import { render, staticRenderFns } from "./voucher-single.vue?vue&type=template&id=407dfaf8&scoped=true"
import script from "./voucher-single.vue?vue&type=script&lang=js"
export * from "./voucher-single.vue?vue&type=script&lang=js"
import style0 from "./voucher-single.vue?vue&type=style&index=0&id=407dfaf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407dfaf8",
  null
  
)

export default component.exports